import smoothScroll from 'smoothscroll'
import { unref } from 'vue'

const getCurrentYPos = () => {
  if (document.body && document.body.scrollTop) {
    return document.body.scrollTop
  }
  if (document.documentElement && document.documentElement.scrollTop) {
    return document.documentElement.scrollTop
  }
  if (window.pageYOffset) {
    return window.pageYOffset
  }
  return 0
}

/**
 * @param {object|function} dialogRef
 * @param {object|function} cardRef
 * @param {number} [duration=250]
 */
export const useDialogFormScroll = (dialogRef, cardRef, duration = 250) => {
  const getContainerAttrs = () => {
    cardRef = typeof cardRef === 'function'
      ? cardRef()
      : cardRef

    cardRef = unref(cardRef)

    const cardEl = cardRef?.$el ?? cardRef
    const dialogTabBodyEl = cardEl.querySelector('.dialog-body-container')
    const containerEl = dialogTabBodyEl ?? cardEl

    const offsetContainer = containerEl.scrollTop - containerEl.getBoundingClientRect().top

    return { containerEl, offsetContainer }
  }

  const onValidationError = (ref) => {
    const el = ref?.$el ?? ref
    if (!el) return
    const offsetEl = el.getBoundingClientRect().top

    const { containerEl, offsetContainer } = getContainerAttrs()

    const stickyHeaderEl = containerEl.querySelector('.sticky-header')
    const offsetHeader = stickyHeaderEl ? stickyHeaderEl.clientHeight : 0

    smoothScroll(offsetEl + offsetContainer - offsetHeader, duration, null, containerEl)
  }

  const scrollToTop = () => {
    const { containerEl } = getContainerAttrs()

    smoothScroll(containerEl.scrollTop * -1, duration, null, containerEl)
  }

  return { onValidationError, scrollToTop }
}

/**
 * @param {number} [duration=250]
 */
export const useFormScroll = (duration = 250) => {
  const onValidationError = (elRef) => {
    const el = elRef.$el ?? elRef

    let y = el.getBoundingClientRect().top // Posição do elemento relativo ao o que está na tela

    y += getCurrentYPos() // Posição do scroll na tela atual

    const header = document.querySelector('.q-header')
    if (header) y -= header.getBoundingClientRect().height // Compensando a altura do header do layout

    smoothScroll(y, duration)
  }

  return { onValidationError }
}
